import { h } from 'vue';

import { Text } from '@/utils';

export default {
    props:
    {
        click:
        {
            type: Function,
            default: null,
        },
    },

    render()
    {
        return h(
            'a',

            {
                class: Text.joinClass(
                    'vh-close',
                    'vh-modal-close',
                    'vh-link-reset'
                ),

                onClick: (e) =>
                {
                    this.$emit('click', e);
                },
            },

            h(
                'i',
                {
                    class: 'bx bx-x',
                },
            ),
        );
    },
};
